/**
 * MAGSDK basic implementation of UfsJson json plugin.
 *
 * @author Igor Zaporozhets <i.zaporozhets@infomir.com>
 */

'use strict';


var UfsJson = require('./ufs.json');

/**
 * Resolve own UfsJson wrapper for each application.
 *
 * @param {Object} config application config
 *
 * @return {UfsJson} UfsJson wrapper instance
 */
module.exports = {
    onAppInit: function ( config, callback ) {
        callback(null, new UfsJson(config.app.packageName));
    }
};
